export default __webpack_public_path__ + "static/media/IN500_old.f77f4a89.png";